import axios from 'axios';
import _ from 'lodash';

import BaseModel from './BaseModel';
import UserModel from './UserModel';
import UrbioticaParkinglocationsModel from './UrbioticaParkinglocationsModel';
import ParkinglocationModel from './ParkinglocationModel';
const BASE = BaseModel.getApiBasePath() + '/api/v1/urbiotica/counters';

export default new class UrbioticaCountersModel {

    constructor() { }

    get(id) {
        return new Promise((resolve, reject) => {
            this.getAll()
                .then((data) => {
                    resolve(_.find(data, { id: id }));
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    getAll(urbioticaParkingLocationID = null) {
        var filter = {};
        if (urbioticaParkingLocationID) {
            filter = _.merge(filter, { where: { and: [{ parkingLocationID: urbioticaParkingLocationID }] } });
        }
        return new Promise((resolve, reject) => {
            axios.get(BASE, {
                params: {
                    access_token: UserModel.getAccessToken(),
                    filter: filter
                }
            })
                .then((response) => {
                    Promise.all([UrbioticaParkinglocationsModel.getAll(), ParkinglocationModel.getAll(true)])
                        .then((r) => {
                            let urbioticaParkingLocations = r[0];
                            let parkingLocations = r[1];
                            let data = [];
                            response.data.map(async (child, idx) => {
                                let uLocation = _.find(urbioticaParkingLocations, { id: child.parkingLocationID });
                                if (!uLocation || uLocation === undefined) {
                                    data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                                } else {
                                    let location = _.find(parkingLocations, { id: uLocation.coreParkingLocationID });
                                    location
                                        ? data.push(Object.assign({}, child, { parkingLocationName: location.Code + ' - ' + location.Name }))
                                        : data.push(Object.assign({}, child, { parkingLocationName: 'Neznámá lokalita' }));
                                }
                            });
                            resolve(data);
                        });
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    create(data) {
        console.log(data);
        return new Promise((resolve, reject) => {
            axios.post(BASE, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    remove(id) {
        return new Promise((resolve, reject) => {
            axios.delete(BASE + '/' + id, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    update(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.put(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    patch(id, data) {
        if (data.id !== undefined) {
            delete data.id;
        }
        return new Promise((resolve, reject) => {
            axios.patch(BASE + '/' + id, data, {
                params: {
                    access_token: UserModel.getAccessToken()
                }
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

}


// WEBPACK FOOTER //
// ./src/components/UrbioticaCountersModel.js